<template>
  <div
    class="timeline scroll"
    id="lead-timeline"
    ref="leadTimeline"
    @scroll="handleScroll"
  >
    <h2
      v-text=" __('Histórico do lead')"
    />

    <div
      class="timeline-centered mt-4"
    >
      <article
        :key="`${time.message}-${index}`"
        class="timeline-entry"
        v-for="(time, index) in timeline"
      >
        <LeadTimelineItem
          v-bind="time"
        />
      </article>
    </div>
    <div v-if="loading && this.currentPage < this.totalPages" class="loader">
      <h2 class="text-center pb-2">
        <i class="fa fa-circle-o-notch fa-spin" />
      </h2>
    </div>
  </div>
</template>

<script>
export default {
  mounted () {
    window.addEventListener('scroll', this.handleScroll);
    this.getTimeline();
    Bus.$on('leadUpdated', () => this.getTimeline());
  },

  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  },

  props: ['hash'],

  data () {
    return {
      currentPage: 1,
      totalPages: 0,
      itemsPerPage:0,
      timeline: [],
      loading: true,
    };
  },

  methods: {
    handleScroll (evt, el) {
      const timelineLoad = this.$refs.leadTimeline;
      const scrollTop = timelineLoad.scrollTop;
      const clientHeight = timelineLoad.clientHeight;
      const scrollHeight = timelineLoad.scrollHeight;

      const timeline = document.getElementById('lead-timeline');
      const header = document.getElementById('the-header');
      const breadcrumb = document.getElementById('bd-breadcrumb');

      if (timeline && header && breadcrumb) {
        const sticky = header.scrollHeight + breadcrumb.scrollHeight + 55;
        if (window.scrollY >= sticky) {
          timeline.classList.add('sticky');
        } else {
          timeline.classList.remove('sticky');
        }
      }

      if (scrollTop != 0 && !this.loading && scrollTop + clientHeight >= scrollHeight - 1) {
        this.currentPage++;
        if (this.currentPage <= this.totalPages) {
          this.loading = true;
          this.getTimeline();
        } else {
          this.loading = false;
        }
      }
    },

    getTimeline () {
      this.$http.get(`/lead/${this.hash}/timeline?page=${this.currentPage}`)
      .then((response) => {
        const newItems = response.body.data.filter((log) => log.message.indexOf('Cadastro Interno') === -1 && log.message.indexOf('Completou') === -1);

        if (this.currentPage === 1) {
          this.timeline = newItems;
        } else {
          this.timeline.push(...newItems);
        }

        this.itemsPerPage = response.body.per_page;
        this.totalPages = response.body.last_page;
      })
      .catch((error) => {
        console.log(error.responseJSON);
      })
      .finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>
